import placeIcon from "../src/assets/place.png";
import timeIcon from "../src/assets/time.png";
import filterIcon from "../src/assets/filter.png";
export const enFilterItems = [
    {
      id: 1,
      title: "Place",
      icon: placeIcon,
      options: [
        {
          id: 1,
          title: "Hong Kong Island",
          value: "Hong Kong Island",
          isSelected: false,
          options:[
 
            {
                id:11,
                title:"Central and Western District",
                value:"Central and Western District",
                isSelected:false,
            },{
                id:12,
                title:"Eastern District",
                value:"Eastern District",
                isSelected:false,
            },{
                id:13,
                title:"Southern District",
                value:"South area",
                isSelected:false,
            },{
                id:14,
                title:"Wan Chai District",
                value:"Wan Chai District",
                isSelected:false,
            },
          ]
        },
        { 
            id: 2, 
            title: "Kowloon", 
            value: "Kowloon", 
            isSelected: false,
            options:[
                 {
                    id:21,
                    title:"Kowloon City District",
                    value:"Kowloon City",
                    isSelected:false,
                },{
                    id:22,
                    title:"Kwun Tong District",
                    value:"Kwun Tong District",
                    isSelected:false,
                },{
                    id:23,
                    title:"Sham Shui Po District",
                    value:"Sham Shui Po District",
                    isSelected:false,
                },{
                    id:24,
                    title:"Wong Tai Sin District",
                    value:"Wong Tai Sin District",
                    isSelected:false,
                },{
                    id:25,
                    title:"Yau Tsim Mong District",
                    value:"Yau Tsim Mong District",
                    isSelected:false,
                },
            ]
        },
        {
          id: 3,
          title: "New Territories",
          value: "New Territories",
          isSelected: false,
          options:[
             {
              id:32,
              title:"Kwai Tsing District",
              value:"Kwai Tsing District",
              isSelected:false,
            },{
              id:33,
              title:"North District",
              value:"North District",
              isSelected:false,
            },{
              id:34,
              title:"Sai Kung District",
              value:"Sai Kung District",
              isSelected:false,
            },{
              id:35,
              title:"Shatin District",
              value:"Shatin District",
              isSelected:false,
            },{
              id:37,
              title:"Tsuen Wan District",
              value:"Tsuen Wan District",
              isSelected:false,
            },{
              id:38,
              title:"Tuen Mun District",
              value:"Tuen Mun District",
              isSelected:false,
            },{
              id:39,
              title:"Yuen Long District",
              value:"Yuen Long District",
              isSelected:false,
            },
          ]
        },
        {
          id: 4,
          title: "Outlying Islands",
          value: "Outlying Islands",
          isSelected: false,
          options:[]
        },
      ],
    },
    {
      id: 2,
      title: "Doctor Type",
      icon: filterIcon,
      options: [
        {
          id: 1,
          title: "GP",
          value: "0cd2c701-ee37-45c9-9a6e-ffc565060d20",
          isSelected: false,
          options:[]
        },
        {
          id: 2,
          title: "SP",
          value: "0045ead3-414a-405e-be50-964172562f5e",
          isSelected: false,
          options:[]
        },
        {
          id: 3,
          title: "PHYSIO",
          value: "e8c8614a-c2ba-40a6-a4d2-ab93539778f4",
          isSelected: false,
          options:[]
        },
      ],
    },
  ]



export const chFilterItems = [
  
    {
      id: 1,
      title: "地址",
      icon: placeIcon,
      options: [
        {
          id: 1,
          title: "香港島",
          value: "Hong Kong Island",
          isSelected: false,
          options:[
            {
                id:11,
                title:"中西區",
                value:"Central and Western District",
                isSelected:false,
            },{
                id:12,
                title:"東區",
                value:"Eastern District",
                isSelected:false,
            },{
                id:13,
                title:"南區",
                value:"South area",
                isSelected:false,
            },{
                id:14,
                title:"灣仔區",
                value:"Wan Chai District",
                isSelected:false,
            },
          ]
        },
        { 
            id: 2, 
            title: "九龍", 
            value: "Kowloon", 
            isSelected: false,
            options:[
                {
                    id:21,
                    title:"九龍城",
                    value:"Kowloon City",
                    isSelected:false,
                },{
                    id:22,
                    title:"觀塘",
                    value:"Kwun Tong District",
                    isSelected:false,
                },{
                    id:23,
                    title:"深水埗",
                    value:"Sham Shui Po District",
                    isSelected:false,
                },{
                    id:24,
                    title:"黄大仙",
                    value:"Wong Tai Sin District",
                    isSelected:false,
                },{
                    id:25,
                    title:"油尖旺",
                    value:"Yau Tsim Mong District",
                    isSelected:false,
                },
            ]
        },
        {
          id: 3,
          title: "新界",
          value: "New Territories",
          isSelected: false,
          options:[
             {
              id:32,
              title:"葵青",
              value:"Kwai Tsing District",
              isSelected:false,
            },{
              id:33,
              title:"北區",
              value:"North District",
              isSelected:false,
            },{
              id:34,
              title:"西貢",
              value:"Sai Kung District",
              isSelected:false,
            },{
              id:35,
              title:"沙田",
              value:"Shatin District",
              isSelected:false,
            },{
              id:37,
              title:"荃灣",
              value:"Tsuen Wan District",
              isSelected:false,
            },{
              id:38,
              title:"屯門",
              value:"Tuen Mun District",
              isSelected:false,
            },{
              id:39,
              title:"元朗",
              value:"Yuen Long District",
              isSelected:false,
            },
          ]
        },
        {
          id: 4,
          title: "離島",
          value: "Outlying Islands",
          isSelected: false,
          options:[]
        },
      ],
    },
    {
      id: 2,
      title: "專科類別",
      icon: filterIcon,
      options: [
        {
          id: 1,
          title: "普通科",
          value: "0cd2c701-ee37-45c9-9a6e-ffc565060d20",
          isSelected: false,
          options:[]
        },
        {
          id: 2,
          title: "專科",
          value: "0045ead3-414a-405e-be50-964172562f5e",
          isSelected: false,
          options:[]
        },
        {
          id: 3,
          title: "物理治療",
          value: "e8c8614a-c2ba-40a6-a4d2-ab93539778f4",
          isSelected: false,
          options:[]
        },
      ],
    },
  ]


//////////////////
// WEBPACK FOOTER
// ./static/data.js
// module id = null
// module chunks = 